import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Skills from "./components/Skills";
import Work from "./components/Work";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Terms from "./components/Terms";
import NotFound from "./components/NotFound";
import CookieConsent from "./components/CookieConsent";
import { SmoothScroll } from "./components/ui/Effects";
import { initAnalytics } from "./utils/analytics";

function MainPortfolio() {
  return (
    <>
      <SmoothScroll />
      <Navbar />
      <main className="relative z-10">
        <Home />
        <About />
        <Skills />
        <Work />
        <Contact />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
    </>
  );
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="App min-h-screen bg-[#0b1120] text-slate-300">
      <Routes>
        <Route path="/" element={<MainPortfolio />} />
        <Route path="/privacy" element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
        <Route path="/terms" element={<><Navbar /><Terms /><Footer /></>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <CookieConsent />
    </div>
  );
}

export default App;
